import * as Sentry from '@sentry/browser'
import config from '../api/Config'
import { NotificationManager } from 'react-notifications'

const isLocal = process.env.NODE_ENV === 'development'
//const isLocal = false

const AUTH_ERROR_CODES = [
    'InvalidParameterException',
    'CodeMismatchException',
    'NotAuthorizedException',
    'UserNotFoundException',
    'UsernameExistsException',
    'InvalidPasswordException',
    'LimitExceededException',
    'ExpiredCodeException',
    'UserNotConfirmedException',
]

function isExpectedAuthError(error) {
    if (!error) return false
    // Cognito errors come as plain objects with a `code` property
    if (error.code && AUTH_ERROR_CODES.includes(error.code)) return true
    // AuthError type (e.g. "Username cannot be empty")
    if (error.__type && AUTH_ERROR_CODES.includes(error.__type)) return true
    if (error.name === 'AuthError') return true
    return false
}

export function initSentry() {
    if (isLocal) {
        return
    }
    else {
        Sentry.init({ dsn: config.SENTRY_DSN })
    }
}

export function logError(error, errorInfo = null) {
    if (isLocal) {
        return
    }
    if (isExpectedAuthError(errorInfo || error)) {
        return
    }
    Sentry.withScope((scope) => {
        errorInfo && scope.setExtras(errorInfo)
        Sentry.captureException(error)
    })
}

export function onError(error) {
    let errorInfo = {}
    let message = error.toString()

    // Auth errors
    if (!(error instanceof Error) && error.message) {
        errorInfo = error
        message = error.message
        error = new Error(message)
    } 
    // API errors
    else if (error.config && error.config.url) {
        errorInfo.url = error.config.url;
    }

    logError(error, errorInfo)

    console.log('ERROR: ', message)
    console.log('error name: ', error.name)
    if (message === 'QuotaExceededError') {
        window.localStorage.clear()
    }
    NotificationManager.error('Something went wrong. Please try again in few moments.')
}

